import React, { Component, Fragment } from "react";
import { Organization } from "@sade/data-access";
import OrganizationDetails from "./organization-details";
import OrganizationChildList from "./organization-child-list";

interface Props {
  organization: Organization;
}

export default class OrganizationManagement extends Component<Props> {
  public constructor(props: Props) {
    super(props);
  }

  public render(): JSX.Element {
    return (
      <Fragment>
        <OrganizationDetails organization={this.props.organization} />
        <OrganizationChildList parentOrganization={this.props.organization} />
      </Fragment>
    );
  }
}
